import React from 'react'
import { Col, Row } from 'antd'
import { ContentInputField } from '../../../../../components/atoms/formFields/inputField/contentInputField'
import SelectOption from '../../../../../components/atoms/formFields/selectOption'

const FormRepeater = ({ type, value, disabled, setProductInfo, infoState, errors, setErrors }) => {
    const unitOptions = {
        cropHeight: [
            { label: "CM", value: "cm" },
            { label: "M", value: "m" },
        ],
        averageYield: [
            { label: "KG", value: "kg" },
            { label: "QUINTAL(QTL)", value: "qtl" },
            { label: "TON", value: "ton" },
        ],
        fruitWeight: [
            { label: "KG", value: "kg" },
            { label: "GM", value: "gm" },
        ],
        maturity: [{ label: "DAYS", value: "days" }],
        seedRate: [
            { label: "QUINTAL(QTL)", value: "qtl" },
            { label: "KG", value: "kg" },
            { label: "GM", value: "gm" },
        ]
    }
    return (
        <div className="dosage-repeater">
            <Row gutter={[12, 12]} className="align-items-center">
                <Col xs={6}>
                    <ContentInputField
                        name="Min"
                        filter={true}
                        value={value?.min}
                        disabled={disabled}
                        errors={errors?.[type + "_min"]}
                        onChange={(e) => {
                            setProductInfo({
                                ...infoState,
                                seedInfo: {
                                    ...infoState.seedInfo,
                                    [type]: {
                                        ...infoState.seedInfo?.[type],
                                        min: e.target.value,
                                    },
                                }
                            });
                            setErrors({
                                ...errors,
                                [type + "_min"]: (e.target.value
                                    ? e.target.value > 0
                                    : true)
                                    ? ""
                                    : type + " is Invalid",
                            });
                        }}
                    />
                </Col>
                <Col xs={6}>
                    <ContentInputField
                        name="Max"
                        filter={true}
                        value={value?.max}
                        disabled={disabled}
                        errors={errors?.[type + "_max"]}
                        onChange={(e) => {
                            setProductInfo({
                                ...infoState,
                                seedInfo: {
                                    ...infoState.seedInfo,
                                    [type]: {
                                        ...infoState.seedInfo?.[type],
                                        max: e.target.value,
                                    },
                                }
                            });
                            setErrors({
                                ...errors,
                                [type + "_max"]: (e.target.value
                                    ? e.target.value > 0
                                    : true)
                                    ? ""
                                    : type + " is Invalid",
                            });
                        }}
                    />
                </Col>
                <Col xs={12}>
                    <SelectOption
                        placeholder="Unit"
                        filter={true}
                        error={errors?.[type + "_unit"]}
                        options={unitOptions[type]}
                        isDisabled={disabled}
                        value={value?.unit ? { label: value?.unit, value: value?.unit } : []}
                        onChange={(val) => {
                            setProductInfo({
                                ...infoState,
                                seedInfo: {
                                    ...infoState.seedInfo,
                                    [type]: {
                                        ...infoState.seedInfo?.[type],
                                        unit: val?.value,
                                    },
                                }
                            });
                            setErrors({
                                ...errors,
                                [type + "_unit"]: (infoState?.seedInfo?.[type]?.min > 0 &&
                                    infoState?.seedInfo?.[type]?.max > 0
                                    ? val?.value
                                    : true) ? ""
                                    : "Unit is Mandatory",
                            });
                        }}
                    />
                </Col>
            </Row>
        </div>
    )
}

export default FormRepeater